export default __webpack_public_path__ + "static/media/full4.2b834971.jpg";